module.exports = __webpack_public_path__ + "static/media/image3.21e7011c.JPG";